import axios from '@/libs/api.request'

export const uploadGerberArchive = (pcbSpecificationId, gerberArchive) => {
  const param = new FormData()
  param.append('gerber_archive', gerberArchive)
  param.append('pcb_specification_id', pcbSpecificationId)
  return axios.request({
    url: 'pcb/upload/gerber',
    data: param,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
